import { Helmet } from 'react-helmet';
import ListVessels from 'src/features/Vessels';
import MainLayout from 'src/layouts';

const VesselsPage = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Vessels Information</title>
      </Helmet>
      <ListVessels />
    </MainLayout>
  );
};

export default VesselsPage;
